import { render, staticRenderFns } from "./DashboardSlideshow.vue?vue&type=template&id=2bad6eca&scoped=true&"
import script from "./DashboardSlideshow.vue?vue&type=script&lang=js&"
export * from "./DashboardSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSlideshow.vue?vue&type=style&index=0&id=2bad6eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad6eca",
  null
  
)

export default component.exports